export default __webpack_public_path__ + "static/media/gzc_paryk_i_marecki.d4fef71c.jpg";